/**
 * Magyar számformázás és rendezés.
 *
 * A megbízás szerint minden szám monospace, jobbra igazított, ezresenként
 * szóközzel tagolva; a betűrend magyar. Ezek itt vannak egy helyen, hogy a
 * képernyők ne találjanak ki mindig újat.
 */

/**
 * Egész szám ezres tagolással: 1 234 567, és négyjegyűnél is: 4 420.
 *
 * A böngésző magyar formázása a négyjegyű számot nem tagolja („4420"), a
 * megbízás szerint viszont ezresenként mindig szóköz jár. Nem törhető
 * szóközzel, hogy egy szám ne essen szét két sorba.
 */
export function ft(n: number | null | undefined): string {
  if (n === null || n === undefined || !Number.isFinite(n)) return '—';
  const egesz = Math.round(n);
  const tagolt = String(Math.abs(egesz)).replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
  return egesz < 0 ? `-${tagolt}` : tagolt;
}

/** Tizedesjegyekkel, ha van értelme: 1 234,5 */
export function szam(n: number | null | undefined, tizedes = 2): string {
  if (n === null || n === undefined || !Number.isFinite(n)) return '—';
  return n
    .toLocaleString('hu-HU', { maximumFractionDigits: tizedes })
    .replace(/ /g, ' ');
}

/** Beírt szöveg számmá alakítása. Elfogadja a vesszőt és a szóközöket. */
export function szamotOlvas(szoveg: string): number | null {
  const t = szoveg.trim().replace(/\s/g, '').replace(',', '.');
  if (!t) return null;
  const n = Number(t);
  return Number.isFinite(n) ? n : null;
}

/** Magyar betűrend. */
export function huRendez(a: string, b: string): number {
  return a.localeCompare(b, 'hu');
}

/** Dátum magyarosan: 2026. 09. 01. */
export function datum(iso: string | null | undefined): string {
  if (!iso) return '—';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return iso;
  return d.toLocaleDateString('hu-HU', { year: 'numeric', month: '2-digit', day: '2-digit' });
}

/**
 * Szerződéslejárat színezése dátumból. (2.0 / 5.8)
 *
 * A szerződések képernyője a szerverről kapott állapotot használja; itt, az
 * éttermek táblájában viszont csak a dátum áll rendelkezésre, ezért ugyanazt
 * a szabályt helyben számoljuk: lejárt → piros, 60 napon belül → sárga.
 */
export const LEJARAT_FIGYELMEZTETES = 60;

export function lejaratOsztaly(datum: string | null): string {
  if (!datum) return '';
  const ma = new Date();
  ma.setHours(0, 0, 0, 0);
  const d = new Date(`${datum}T00:00:00`);
  if (Number.isNaN(d.getTime())) return '';
  const nap = Math.round((d.getTime() - ma.getTime()) / 86_400_000);
  if (nap < 0) return 'lejart';
  if (nap <= LEJARAT_FIGYELMEZTETES) return 'lejar-hamarosan';
  return '';
}
